var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 26,
    viewBox: "0 0 18 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    transform: "translate(-12)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12.49970149993896 25.12069892883301 L 12.49970149993896 0.5000028610229492 L 29.50000190734863 0.5000028610229492 L 29.50000190734863 24.74425888061523 L 21.54085159301758 15.7635326385498 L 21.16666030883789 15.34131240844727 L 20.79247093200684 15.7635326385498 L 12.49970149993896 25.12069892883301 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12.99970149993896 23.80266380310059 L 21.16666030883789 14.58745288848877 L 29.00000190734863 23.42622375488281 L 29.00000190734863 1.000002861022949 L 12.99970149993896 1.000002861022949 L 12.99970149993896 23.80266380310059 M 30.00000190734863 26.00000381469727 L 29.94452095031738 25.99968338012695 L 21.16666030883789 16.09516334533691 L 12.38879108428955 25.99969291687012 L 11.99970149993896 25.99968338012695 L 11.99970149993896 2.86102294921875e-06 L 30.00000190734863 2.86102294921875e-06 L 30.00000190734863 26.00000381469727 Z",
    stroke: "none",
    fill: "#707070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.9b51f828c9549173f07603be13eb46f7.svg";
export { ForwardRef as ReactComponent };